'use client';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import StatsSection from '@/components/StatsSection';
import BenefitsSection from '@/components/BenefitsSection';
import FeaturedSection from '@/components/FeaturedSection';
import CatalogSection from '@/components/CatalogSection';
import PersonasSection from '@/components/PersonasSection';
import ComparisonSection from '@/components/ComparisonSection';
import HowItWorksSection from '@/components/HowItWorksSection';
import CheckoutSection from '@/components/CheckoutSection';
import LicenseSection from '@/components/LicenseSection';
import FAQSection from '@/components/FAQSection';
import FinalCTASection from '@/components/FinalCTASection';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <div style={{ background: 'var(--background)', color: 'var(--foreground)', fontFamily: "'Plus Jakarta Sans', 'DM Sans', sans-serif" }}>
      <Header />
      <main id="main-content">
        <HeroSection />
        <StatsSection />
        <BenefitsSection />
        <FeaturedSection />
        <CatalogSection />
        <PersonasSection />
        <ComparisonSection />
        <HowItWorksSection />
        <CheckoutSection />
        <LicenseSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
